export enum DocumentType {
    RAW = "raw",
    CLEANED = "cleaned",
    LABELED = "labeled",
    OTHER = "other",
}

export enum CreatedByType {
    USER = "user",
    SERVICE = "service",
}

export enum FileSource {
    CODAT = "codat",
    SYSTEM_UPLOADED = "system_uploaded",
    USER_UPLOADED = "user_uploaded",
}

export enum UserReportedUploadType {
    BALANCE_SHEET = "balance_sheet",
    INCOME_STATEMENT = "income_statement",
    FINANCIAL_SUMMARY = "financial_summary",
    COMPANY_DECK = "company_deck",
    CAP_TABLE = "cap_table",
    TRANSACTION_DATA = "transaction_data",
    OTHER = "other",
    UNKNOWN = "unknown",
}

export interface File {
    id: string;
    name: string;
    documentType: DocumentType;
    source: FileSource;
    meta: Record<string, string> & {
        userReportedUploadType?: UserReportedUploadType;
    };
    mimeType: string;
    companyId: string;
    sourceConnectorType: string;
    sourceConnectorId: string;
    createdAt: string;
    updatedAt: string;
    size: string;
    createdByType: CreatedByType;
    createdByUserId: string;
    createdByServiceName: string;
}
